goog.provide('el8.uiwidget.TabbedNav');

goog.require('el8.service.tooltip');
goog.require('el8.template.uiwidget.TabbedNav');

/**
 * This is a widget for managing a set of tabs, each of which corresponds
 * to some element that we want to show/hide. By default, the tabs are horizontal,
 * but they can be manipulated via CSS to be vertical (practice home does this –
 * see apphome/reqact/main.js). Other example usages include the handouts dialog
 * (viewEducationalHandouts.js) and the patient passport timeline (timelanePane.js).
 *
 * It can optionally display a count of items for each tab, if provided an updateCountFn.
 */
el8.uiwidget.TabbedNav = function() {
    this.tabSpecList = [];
    this.container = null;
    this.showingTab = null;
    this.tabContentMap = {};
    this.tabShowFnMap = {};
    this.tabUpdateCountFnMap = {};
};

el8.uiwidget.TabbedNav.prototype.init = function(opts) {

    opts = opts || {};

    // allow for custom definitions of the class
    this._tabSectionClass = opts.tabSectionClass || 'el8TabSection';
    this._tabItemClass = opts.tabItemClass || 'el8TabItem';
    this._tabItemDisabledClass = opts.tabItemDisabledClass || 'el8TabItemDisabled';
    this._tabCountClass = opts.tabCountClass || 'el8TabItemCount';

    this._isSectionHeader = opts.isSectionHeader || false;

    var wrapper = opts.wrapper || $(document.body);
    this.container = opts.containerFn ?
        $(opts.containerFn()) :
        $(el8.template.uiwidget.TabbedNav.content(
            {
                tabSectionClass: this._tabSectionClass,
                isSectionHeader: this._isSectionHeader
            }
        ));
    wrapper.prepend(this.container);

    this.tabTemplateFn = opts.tabTemplateFn ||
        el8.template.uiwidget.TabbedNav.tab;

    this.tabDisabledTemplateFn = opts.tabDisabledTemplateFn ||
        el8.template.uiwidget.TabbedNav.disabledTab;

    opts.list = opts.list || [];

    for (var i=0; i<opts.list.length; i++) {
        this.addTab(opts.list[i]);
    }

    var that = this;
    var tabSelectFn = function() {
        var name = $(this).attr('data-tab');
        if (name !== that.showingTab) {
            that.showTab(name);
        }
    };
    this.container.on('click', '.tabbed-nav-item',  function(var_args) {
        tabSelectFn.call(this, arguments);
    }).on('keyup', '.tabbed-nav-item',  function(e) {
        if (e.keyCode === KEYS.ENTER) { tabSelectFn.call(this, arguments); }
    });
};

el8.uiwidget.TabbedNav.prototype.hideTab = function(name) {
    // if tabItemClass is '.el8TabItem' then the selection class will be '.el8TabItemSelected'
    this.getTabElt(name)
        .removeClass(this._tabItemClass+'Selected ebs-active')
        .addClass(this._tabItemClass);
    if (this.tabContentMap[name]) { this.tabContentMap[name].hide(); }
    this.unhighlightTabCount(name);
    if (this.showingTab === name) {
        // If showingTab does not match name, we're probably hiding a tab we just added, in which
        // case, we don't want to wipe out the tab we're actually showing. The possibility of data
        // getting out of sync should be mitigated by showTab setting name whenever the tab changes.
        this.showingTab = null;
    }
};

el8.uiwidget.TabbedNav.prototype.showTab = function(name) {
    if (this.showingTab) {
        this.hideTab(this.showingTab);
    }
    this.getTabElt(name)
        .addClass(this._tabItemClass+'Selected ebs-active')
        .removeClass(this._tabItemClass);
    this.showingTab = name;
    if (this.tabContentMap[name]) { this.tabContentMap[name].show(); }
    if (this.tabShowFnMap[name]) { this.tabShowFnMap[name](name); }
    this.highlightTabCount(name);
    this.updateTabCount(name);
};

el8.uiwidget.TabbedNav.prototype.addTab = function(opts) {
    $.extend(opts, {
        tabItemClass: this._tabItemClass,
        tabCountClass: this._tabCountClass,
        tabItemDisabledClass: this._tabItemDisabledClass
    });

    this.tabSpecList.push(opts);
    opts.hasCount = Boolean(opts.updateCountFn);

    if (opts.disabled) {
        this.container.append(this.tabDisabledTemplateFn(opts));
    } else {
        this.container.append(this.tabTemplateFn(opts));
    }

    // optionally add tooltip
    if (opts.tooltip) {
        el8.service.tooltip.create({
            anchor: $('li[data-tab="' + opts.name + '"]', this.container),
            text: opts.tooltip
        });
    }

    if (opts.tabClass) {
        this.getTabElt(opts.name).addClass(opts.tabClass);
    }
    if (opts.additionalClass) {
        this.getTabElt(opts.name).addClass(opts.additionalClass);
    }
    if (opts.contentDiv) {
        this.tabContentMap[opts.name] = opts.contentDiv;
        this.hideTab(opts.name);
    }
    if (opts.updateCountFn) {
        this.tabUpdateCountFnMap[opts.name] = opts.updateCountFn;
        this.updateTabCount(opts.name);
    }
    if (opts.showTabFn) {
        this.tabShowFnMap[opts.name] = opts.showTabFn;
    }
};

el8.uiwidget.TabbedNav.prototype.hideTabButton = function(name) {
    this.getTabElt(name).hide();
};

el8.uiwidget.TabbedNav.prototype.showTabButton = function(name) {
    this.getTabElt(name).show();
};

el8.uiwidget.TabbedNav.prototype.getTabElt = function(name) {
    return $('.tabbed-nav-item[data-tab="'+name+'"]', this.container);
};
el8.uiwidget.TabbedNav.prototype.getTabCountElt = function(name) {
    return $('.tabbed-nav-count[data-tab="'+name+'"]', this.container);
};

el8.uiwidget.TabbedNav.prototype.updateTabCount = function(name) {
    if (this.tabUpdateCountFnMap[name]) {
        var $countElem = this.getTabCountElt(name);
        $countElem.text(this.tabUpdateCountFnMap[name](name, this.tabContentMap[name], $countElem));
    }
};

el8.uiwidget.TabbedNav.prototype.updateAllTabCounts = function() {
    for (var i=0; i<this.tabSpecList.length; i++) {
        var opts = this.tabSpecList[i];
        this.updateTabCount(opts.name);
    }
};

el8.uiwidget.TabbedNav.prototype.highlightTabCount = function(name) {
    if (this.tabUpdateCountFnMap[name]) {
        this.getTabCountElt(name)
            .addClass(this._tabCountClass+'Selected')
            .removeClass(this._tabCountClass);
    }
};

el8.uiwidget.TabbedNav.prototype.unhighlightTabCount = function(name) {
    if (this.tabUpdateCountFnMap[name]) {
        this.getTabCountElt(name)
            .removeClass(this._tabCountClass+'Selected')
            .addClass(this._tabCountClass);
    }
};
el8.uiwidget.TabbedNav.prototype.getShowingTab = function() {
    return this.showingTab;
};
el8.uiwidget.TabbedNav.prototype.getFirstTab = function() {
    if (!this.tabSpecList.length) { return null; }
    return this.tabSpecList[0].name;
};
el8.uiwidget.TabbedNav.prototype.getTabExists = function(name) {
    return Boolean(this.getTabElt(name).length);
};
